'use strict'

export let norwegian={
  general: {
    executive: "Eier",
    projectManager: "Programleder",
    risks:"Riski",
    issues :"Saker"
  },
  reports: {
    heading: "Genererte rapporter",
    highlightReport: "Siste statusrapport",
    brief: "Programforslag",
    pid: "Styringsdokument"
  },
  identifyingProgrammeProcess: {
    title: "Anbefalte aktiviteter ved identifisering av program:",
    activities: {
      sponsoringTheProgramme : {
        title: "Forankre programmet i ledelsen"
      },
      confirmProgramMandate: {
        title: "Bekrefte mandatet for programmet"
      },
      appointSROAndProgrammeBoard: {
        title: "Utpeke eier av programmet og programstyret"
      },
      produceProgrammeBrief: {
        title: "Utarbeide programforslaget"
      },
      developProgrammePreparationPlan: {
        title: "Utvikle plan for å forberede programmet"
      },
      independentReview: {
        title: "Uavhengig gjennomgang"
      },
      approvalToProceed: {
        title: "Godkjenning til å fortsette"
      }
    }
  },
  definingProgrammeProcess: {
    title: "Anbefalte aktiviteter ved presisering av program:",
    activities: {
      establishInfrastructure : {
        title: "Etablere infrastruktur for å 'Presisere programmet'"
      },
      establishTeam: {
        title: "Sette sammen teamet som skal presisere programmet"
      },
      identifyStakeholders: {
        title: "Identifisere og analysere interessentene"
      },
      refineVision: {
        title: "Forbedre visjonen"
      },
      developBlueprint: {
        title: "Utvikle fremtidsmodellen"
      },
      developBenefitProfiles: {
        title: "Utvikle gevinstprofiler"
      },
      modelBenefits: {
        title: "Utarbeide gevinstmodell og avgrens gevinstprofilene"
      },
      validateBenefits: {
        title: "Bekrefte gevinstene"
      },
      designProjectsDossier: {
        title: "Beskrive prosjektene i programmet"
      },
      identifyTranches: {
        title: "Identifisere seksjonene i programmet (milepælene)"
      },
      designProgrammeOrganization: {
        title: "Utforme programorganisasjonen"
      },
      developGovernanceArrangements: {
        title: "Definere styringsmekanismene for programmet"
      },
      developProgrammePlan: {
        title: "Utarbeid programplanen"
      },
      confirmBusinessCase: {
        title: "Utvikle og bekreft begrunnelsen for programmet"
      },
      consolidateProgrammeDefinition: {
        title: "Sett sammen programdefinisjonen"
      },
      prepareFirstTranche: {
        title: "Forbered første seksjon i programmet"
      },
      approvalToProceed: {
        title: "Godkjenning til å fortsette"
      }
    }
  }
};



// WEBPACK FOOTER //
// ./views/programme/labels/norwegian.js